// Layout.js
import Button from 'components/Button';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { MdContacts } from 'react-icons/md';
import { GrGallery } from 'react-icons/gr';
// import { PiCurrencyDollarBold, } from "react-icons/pi";
import { FaCalendarAlt, FaEnvelope } from 'react-icons/fa';
// import { FaNewspaper } from 'react-icons/fa';
import { MdDashboard } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
// import { FaVideo } from 'react-icons/fa';
import { FaUserTie } from 'react-icons/fa';
import { FaTags } from 'react-icons/fa';

import logo from '../asserts/img/logo.png';
// import Header from './Header';
// import Footer from './Footer';
// import { linklists, headersClasses } from './RouterList';
const currentUrl = window.location.pathname;
const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
const isStoryRoute = currentUrl.startsWith('/story');
const isRepoterRoute = currentUrl.startsWith('/repoters');
const isCategoryRoute = currentUrl.startsWith('/category');

const Layout = ({ children }) => {
  const [toggled, setToggle] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const dispatch = useDispatch();
  const nevigate = useNavigate();

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const logoutHandler = async (e) => {
    e.preventDefault();
    try {
      dispatch(logout());
      nevigate('/signin');
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div id="wrapper">
        <ul
          className={toggled ? 'navbar-nav sidebar sidebar-danger toggled' : 'navbar-nav sidebar sidebar-danger accordion'}
          id="accordionSidebar"
        >
          <Link className="text-decoration-none justify-content-start" to="/dashboard">
            <div className="text-center">
              <img src={logo} alt="Bundeli Chugli" className="img-fluid adminlogo" />
            </div>
          </Link>
          {/* <hr className="sidebar-divider my-0" /> */}
          <li className="nav-item text-danger">
            <Link className="nav-link" to="/dashboard">
              <MdDashboard className="mr-1" />
              <span>Dashboard</span>
            </Link>
          </li>

          <li className={`nav-item text-danger ${lastSegment === 'ournews' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'ournews'}
              onClick={() => toggleMenu('ournews')}
            >
              <FaCalendarAlt className="mr-1" />
              <span>Add Our News </span>
            </Link>
            <div id="ournews" className={`collapse ${openMenu === 'ournews' ? 'show' : ''}`} aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/ournews/add">
                  Add News
                </Link>
                <Link className="collapse-item" to="/ournews">
                  Our News List
                </Link>
              </div>
            </div>
          </li>

          <li className={`nav-item text-danger ${isRepoterRoute ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'repoters'}
              onClick={() => toggleMenu('repoters')}
            >
              <FaUserTie className="mr-1" />
              <span>Repoters Profile</span>
            </Link>
            <div id="repoters" className={`collapse ${openMenu === 'repoters' ? 'show' : ''}`} aria-labelledby="headingRepoters">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/repoters/add">
                  Add Repoter
                </Link>
                <Link className="collapse-item" to="/repoters">
                  Repoters List
                </Link>
              </div>
            </div>
          </li>

          {/* <li className={`nav-item text-danger ${lastSegment === 'media' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              href="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'media'}
              onClick={() => toggleMenu('media')}
            >
              <FaVideo className="mr-2" /> 
              <span>Video</span>
            </Link>

            <div id="media" className={`collapse ${openMenu === 'media' ? 'show' : ''}`} aria-labelledby="headingMedia">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/media/add">
                  Add Video
                </Link>

                <Link className="collapse-item" to="/media">
                  Video List
                </Link>
              </div>
            </div>
          </li> */}

          {/* Our GAllery */}
          <li className={`nav-item text-danger ${lastSegment === 'gallery' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'gallery'}
              onClick={() => toggleMenu('gallery')}
            >
              <GrGallery className="mr-1" />
              <span>Our Gallery</span>
            </Link>
            <div id="ourteam" className={`collapse ${openMenu === 'gallery' ? 'show' : ''}`} aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/gallery/add">
                  Add Our Gallery
                </Link>
                <Link className="collapse-item" to="/gallery">
                  Our Gallery List
                </Link>
              </div>
            </div>
          </li>

          {/* Story */}
          <li className={`nav-item text-danger ${isStoryRoute ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'story'}
              onClick={() => toggleMenu('story')}
            >
              <GrGallery className="mr-1" />
              <span>Story</span>
            </Link>
            <div id="story" className={`collapse ${openMenu === 'story' ? 'show' : ''}`} aria-labelledby="headingStory">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/story/add">
                  Add Story
                </Link>
                <Link className="collapse-item" to="/story">
                  Story List
                </Link>
              </div>
            </div>
          </li>

          {/* Category */}
          <li className={`nav-item text-danger ${isCategoryRoute ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'category'}
              onClick={() => toggleMenu('category')}
            >
              <FaTags className="mr-1" />
              <span>Category</span>
            </Link>
            <div id="category" className={`collapse ${openMenu === 'category' ? 'show' : ''}`} aria-labelledby="headingCategory">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/category/add">
                  Add Category
                </Link>
                <Link className="collapse-item" to="/category">
                  Category List
                </Link>
                <Link className="collapse-item" to="/category/update">
                  Update Category
                </Link>
              </div>
            </div>
          </li>

          {/* Contact Us */}
          {/* <li className={`nav-item text-danger ${lastSegment === 'contactus' ? 'active' : ''}`}>
                        <Link
                            className="nav-link collapsed"
                            to="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'contactus'}
                            onClick={() => toggleMenu('contactus')}
                        >
                            <MdContacts className='mr-1' />
                            <span>Enquiry</span>
                        </Link>
                        <div
                            id="contactus"
                            className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}
                            aria-labelledby="headingTwo"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item text-danger" to="/contactus">Enquiry List</Link>
                            </div>
                        </div>
                    </li> */}

          <li className={`nav-item text-danger ${lastSegment === 'contactus' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              aria-expanded={openMenu === 'contactus'}
              onClick={() => toggleMenu('contactus')}
            >
              <MdContacts className="mr-1" />
              <span>Enquiry</span>
            </Link>

            <div id="contactus" className={`collapse ${openMenu === 'contactus' ? 'show' : ''}`}>
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item text-danger" to="/contactus">
                  Enquiry List
                </Link>
              </div>
            </div>
          </li>

          {/* teammessage  */}
          <li className={`nav-item text-danger ${lastSegment === 'teammessage' ? 'active' : ''}`}>
            <Link
              className="nav-link text-danger collapsed"
              to="#"
              data-toggle="collapse"
              aria-expanded={openMenu === 'teammessage'}
              onClick={() => toggleMenu('teammessage')}
            >
              <FaEnvelope className="mr-1" /> {/* TeamMessage icon */}
              <span>advertising</span>
            </Link>

            <div id="teammessage" className={`collapse ${openMenu === 'teammessage' ? 'show' : ''}`} aria-labelledby="headingTeamMessage">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/team-message/add">
                  Add advertising
                </Link>
                <Link className="collapse-item" to="/team-message/list">
                  advertising List
                </Link>
              </div>
            </div>
          </li>

          {/* schoolnotification */}
          {/* <li className={`nav-item text-danger ${lastSegment === 'schoolnotification' ? 'active' : ''}`}>
                        <Link
                            className="nav-link text-danger collapsed"
                            href="#"
                            data-toggle="collapse"
                            aria-expanded={openMenu === 'schoolnotification'}
                            onClick={() => toggleMenu('schoolnotification')}
                        >
                            <FaBell className='mr-1' /> 
                            <span>School Notifications</span>
                        </Link>
                        <div
                            id="schoolnotification"
                            className={`collapse ${openMenu === 'schoolnotification' ? 'show' : ''}`}
                            aria-labelledby="headingSchoolNotifications"
                        >
                            <div className="bg-white py-2 collapse-inner rounded">
                                <Link className="collapse-item" to="/schoolnotifications/add">Add Notification</Link>
                                <Link className="collapse-item" to="/schoolnotifications/list">Notifications List</Link>
                            </div>
                        </div>
                    </li> */}

          <div className="text-center text-danger d-none d-md-inline mt-5">
            <button className="rounded-circle border-0 text-danger" id="sidebarToggle" onClick={() => setToggle(!toggled)}></button>
          </div>
        </ul>

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
              <button id="sidebarToggleTop" onClick={() => setToggle(!toggled)} className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
              </button>
              <ul className="navbar-nav ml-auto">
                {/* <div className="topbar-divider d-none d-sm-block"></div> */}
                <li className="nav-item dropdown no-arrow">
                  <Link
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="userDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="mr-2 d-none d-lg-inline admintext small">Admin</span>
                    <IoPersonCircleSharp size={20} style={{ color: '#5B0BB5' }} />
                  </Link>
                  <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                    <div className="dropdown-divider"></div>
                    <Button className="dropdown-item" text="Logout" onclickfun={logoutHandler} />
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  </div>
                </li>
              </ul>
            </nav>
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
